import React from 'react';

import Badge from '@atlaskit/badge';

const BadgeImportantExample = (): React.JSX.Element => {
	return <Badge appearance="important">{25}</Badge>;
};

export default BadgeImportantExample;
